import {
  Core,
  QUESTIONNAIRE_TEMPLATE_DETAIL,
  QUESTIONNAIRE_TEMPLATE_PUBLISH,
  QUESTIONNAIRE_TEMPLATES,
} from '../Core';
import type {
  CreateTemplateBody,
  TemplateEditDetail,
  TemplateListParams,
  TemplateSummary,
  UpdateTemplateBody,
} from './types';

class QuestionnaireTemplates extends Core {
  listTemplates = async (params: TemplateListParams) =>
    this.get<TemplateSummary[]>(QUESTIONNAIRE_TEMPLATES(), {
      customerIds: params.customerIds.join(','),
      grouping: params.grouping,
    });

  getTemplateForEdit = async (id: number) =>
    this.get<TemplateEditDetail>(QUESTIONNAIRE_TEMPLATE_DETAIL(id));

  createTemplate = async (body: CreateTemplateBody) =>
    this.post<TemplateEditDetail>(QUESTIONNAIRE_TEMPLATES(), body);

  updateTemplate = async ({
    id,
    body,
  }: {
    id: number;
    body: UpdateTemplateBody;
  }) => this.put<TemplateEditDetail>(QUESTIONNAIRE_TEMPLATE_DETAIL(id), body);

  deactivateTemplate = async (id: number) =>
    this.delete(QUESTIONNAIRE_TEMPLATE_DETAIL(id));

  publishTemplate = async (id: number) =>
    this.post<TemplateSummary>(QUESTIONNAIRE_TEMPLATE_PUBLISH(id));
}

export const questionnaireTemplates = new QuestionnaireTemplates();
